import { RouteRecordRaw } from 'vue-router';
import languages from '../../../../content-repo/content/config/languages.yml';

function buildPath(routeName: string): string {
  const languageNames = `csharp|${Object.keys(languages).join('|')}`;
  // Hack: Add additional '/' in front which is ignored by the router but increases priority, so that it applies before other routes
  return `//:product(.*)?/${routeName}/:language(${languageNames})?`;
}
export function buildUseCaseLanguageRoute(): RouteRecordRaw {
  return {
    path: buildPath('use-cases'),
    component: () => import('../pages/UseCasesPage.vue'),
    meta: { title: 'title.useCases' },
  };
}

export function buildTutorialLanguageRoute(): RouteRecordRaw {
  return {
    path: buildPath('tutorials'),
    component: () => import('../pages/TutorialsPage.vue'),
    meta: { title: 'title.tutorials' },
  };
}
